// class name were kept lowercase to match data

export class CrDetails {
  crInfo?: crInfo = new crInfo();
  crTableInfo?: tableTypes;
  dataProcessingStatus?: string;
  MultipleSummaryAccounts? : any[]

  historyCheckAccounts? :any[];
  savedMultipleAccountSummary? :any[];
  MultipleSummaryHeader? : any[]
  AccountRegisteredWithPhotoIdHeader? : any[]
}


export class crInfo {
  id?: string;
  startDate?: string;
  endDate?: string;
  crProcessingFinishDate?: string;
  lastProcessDate?: string;
  currentProcessDate?: string;
  nextProcessDate?: string;
  dataProcessStatus?: string;
  crProcessStartDate?: string;
  crStatus?: string;
  overallCrProgressPercentage?: string;
  crName?: string;
  crType?: string;
  productSegment?: string;
  description?: string;
  crLogic?: string;
}


export class tableTypes{
  Base? : tableInfo[];
  Annexure? : tableInfo[];
  Summary? : tableInfo[];
  Insight? : tableInfo[];
}


export class tableInfo {
  source?: string;
  design_id?: string;
  obj_name?: string;
  risk_type?: string;
  description?: string;
  flag_logic?: string;
  data_process_status?: string;
  isGraphAvailable?:boolean;
}


export enum TableNames{
  mcr_annex_account = 'Account Based Annexure Table',
  mcr_annex_phId = 'Photo ID Based Annexure Table',
}
